import type { IconNode } from '../types';

/**
 * @name escalator-arrow-down-left
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8Y2lyY2xlIGN4PSI5IiBjeT0iMyIgcj0iMSIgLz4KICA8cGF0aCBkPSJNOSA3djMiIC8+CiAgPHBhdGggZD0iTTE3IDNjLS42IDAtMS4zLjMtMS43LjdMNiAxM0g0YTIgMiAwIDAgMCAwIDRoM2MuNiAwIDEuMy0uMyAxLjctLjdMMTggN2gyYTIgMiAwIDAgMCAwLTRaIiAvPgogIDxwYXRoIGQ9Im0yMiAxMy05IDkiIC8+CiAgPHBhdGggZD0iTTEzIDE4djRoNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/escalator-arrow-down-left
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const escalatorArrowDownLeft: IconNode = [
  ['circle', { cx: '9', cy: '3', r: '1', key: 'm9j37t' }],
  ['path', { d: 'M9 7v3', key: 'oewvmk' }],
  [
    'path',
    {
      d: 'M17 3c-.6 0-1.3.3-1.7.7L6 13H4a2 2 0 0 0 0 4h3c.6 0 1.3-.3 1.7-.7L18 7h2a2 2 0 0 0 0-4Z',
      key: '16avuf',
    },
  ],
  ['path', { d: 'm22 13-9 9', key: '1co6fw' }],
  ['path', { d: 'M13 18v4h4', key: '7j9c1u' }],
];

export default escalatorArrowDownLeft;
